import React, { useMemo, useRef } from "react";
import { Table, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import "./Scoreboard.css";
import { useHistory, useParams, useLocation } from "react-router-dom";
import SideNav from "../../Sidenav";
import DemographicsPatientDetail from "../DemographicsPatientDetail";
import { useSelector, useDispatch } from "react-redux";
import { GetSideNav } from "../../../StateManagement/Reducers/ScheduleState";
import { useEffect, useState } from "react";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import {
  downloadScoreboardPDF,
  ScoreboardReportComponent,
} from "./ScoreboardPDFReport";
import { Modal } from "react-bootstrap";
import TemplateWorkAreas from "../../setting/Templates/TemplateWorkAreas";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import { ArrowLeftOutlined } from "@ant-design/icons";
import GetStartedPopup from "../../popups/GetStartedPopup";
import { Popup } from "semantic-ui-react";
const getDefaultColors = (count) => {
  if (count === 3) {
    return ["#27AE60", "#F2C94C", "#EB5757"];
    // Green, Yellow, Red
  }

  if (count === 4) {
    return ["#56CCF2", "#27AE60", "#F2994A", "#EB5757"];
    // SkyBlue, Green, Orange, Red
  }

  if (count === 5) {
    return ["#56CCF2", "#27AE60", "#F2C94C", "#F2994A", "#EB5757"];
    // SkyBlue, Green, Yellow, Orange, Red
  }

  // fallback for any other count
  const base = ["#56CCF2", "#27AE60", "#F2C94C", "#F2994A", "#EB5757"];
  return base.slice(0, count);
};

const SingleGaugeDisplay = ({ title, score, guideArray }) => {
  const dynamicGuide = useMemo(() => {
    const colors = getDefaultColors(guideArray.length);

    return guideArray.map((item, index) => ({
      min: item.min,
      max: item.max,
      severity: item.label || item.severity,
      score:
        item.min === item.max ? String(item.min) : `${item.min}-${item.max}`,
      color: colors[index] || "#999",
    }));
  }, [guideArray]);

  const maxScore = dynamicGuide.length
    ? Math.max(...dynamicGuide.map((g) => g.max))
    : 10;

  const severityLevel = useMemo(() => {
    if (!dynamicGuide.length) return null;

    const matched = dynamicGuide.find((g) => score >= g.min && score <= g.max);
    if (matched) return matched;

    const lastRange = dynamicGuide[dynamicGuide.length - 1];
    if (score > lastRange.max) return lastRange;
    if (score < dynamicGuide[0].min) return dynamicGuide[0];

    return null;
  }, [score, dynamicGuide]);

  const activeIndex = useMemo(() => {
    if (!dynamicGuide.length) return -1;
    const index = dynamicGuide.findIndex(
      (g) => score >= g.min && score <= g.max,
    );
    if (index !== -1) return index;
    if (score > dynamicGuide[dynamicGuide.length - 1].max) {
      return dynamicGuide.length - 1;
    }
    if (score < dynamicGuide[0].min) {
      return 0;
    }
    return -1;
  }, [score, dynamicGuide]);

  const radius = 80;
  const strokeWidth = 12;
  const center = 100;

  const polarToCartesian = (cx, cy, r, angle) => {
    const rad = (angle - 180) * (Math.PI / 180);
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  };

  const describeArc = (startAngle, endAngle, color) => {
    const start = polarToCartesian(center, center, radius, endAngle);
    const end = polarToCartesian(center, center, radius, startAngle);
    return (
      <path
        d={`M ${start.x} ${start.y} A ${radius} ${radius} 0 0 0 ${end.x} ${end.y}`}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
      />
    );
  };

  const TOTAL_ARC = 180;
  const SEGMENT_COUNT = dynamicGuide.length;
  const GAP = 14;

  const segmentAngle =
    SEGMENT_COUNT > 1
      ? (TOTAL_ARC - GAP * (SEGMENT_COUNT - 1)) / SEGMENT_COUNT
      : TOTAL_ARC;

  const segments = dynamicGuide.map((item, i) => {
    const start = i * (segmentAngle + GAP);
    const end = start + segmentAngle;
    return {
      start,
      end,
      color: item.color,
    };
  });

  return (
    <div className="scoreboard-flex-row" style={{ marginBottom: "20px" }}>
      <div className="gauge-section">
        <h4 className="gauge-label-top">{title || "Score"}</h4>

        <div className="gauge-wrapper">
          <svg width="400" height="200" viewBox="0 0 200 120">
            {segments.map((seg, i) => {
              const strokeColor = i <= activeIndex ? seg.color : "#E0E0E0";
              return (
                <React.Fragment key={i}>
                  {describeArc(seg.start, seg.end, strokeColor)}
                </React.Fragment>
              );
            })}
            {Array.from({ length: maxScore + 1 }).map((_, i) => {
              const angle = maxScore > 0 ? 5 + ((175 - 5) / maxScore) * i : 0;
              const tickRadius = radius - 18;
              const { x, y } = polarToCartesian(
                center,
                center,
                tickRadius,
                angle,
              );

              return <circle key={i} cx={x} cy={y} r="1" fill="#BDBDBD" />;
            })}

            <text x="14" y="118" fontSize="10" fill="#888" textAnchor="middle">
              0
            </text>
            <text x="186" y="118" fontSize="10" fill="#888" textAnchor="middle">
              {maxScore}
            </text>
          </svg>

          <div className="gauge-value-display">
            <div className="gv-number">{score}</div>
            <div className="gv-text">{severityLevel?.severity}</div>
          </div>
        </div>
      </div>

      <div className="info-section">
        {dynamicGuide.length > 0 && activeIndex === dynamicGuide.length - 1 && (
          <div className="alert-box">
            {" "}
            <div className="alert-row">
              {" "}
              <div className="alert-icon-wrapper">
                {" "}
                <span className="alert-icon">!</span>{" "}
              </div>{" "}
              <div className="alert-content">
                {" "}
                <div className="alert-title">
                  {" "}
                  Critical Alert - High Risk Assessment Score{" "}
                </div>{" "}
                <div className="alert-description">
                  {" "}
                  This patient's assessment result indicates a high-risk
                  condition that requires immediate clinical attention{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>
        )}
        <div className="gad-guide">
          <div className="gad-title">
            {title ? `${title} Scoring Guide` : "Scoring Guide"}
          </div>
          <div className="gad-table">
            <div className="gad-header">
              <div className="gad-col-1">Score</div>
              <div className="gad-col-2">Severity</div>
            </div>{" "}
            {dynamicGuide.map((item, idx) => (
              <div key={idx} className="gad-row">
                <div className="gad-col-1">
                  <span
                    className="gad-dot"
                    style={{ backgroundColor: item.color }}
                  />
                  <span>{item.score}</span>
                </div>
                <div className="gad-col-2">{item.severity}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const Scoreboard = () => {
  const history = useHistory();
  const downloadBtnRef = useRef(null);
  const scoreBoardTitleRef = useRef(null);
  const scoreboardPdfRef = useRef(null);
  const { pid, sid } = useParams();
  const patientId = pid;
  const screeningFormId = sid;

  const [facilityInfo, setFacilityInfo] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ShowAddForms, setShowAddForms] = useState(false);
  const [AlertsMsg, setAlertMsg] = useState("");
  const [ModalAlerShow, setModalAlerShow] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [content, setcontent] = useState("");
  const [EditDocName, setEditDocName] = useState("");
  const [rows, setfutureId] = useState([]);
  const [id, setid] = useState();
  const [showStep8Popup, setShowStep8Popup] = useState(false);
  const [showStep9Popup, setShowStep9Popup] = useState(false);
  var provider = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  useEffect(() => {
    axiosInstance
      .get("/vozonew/patient?pid=" + patientId)
      .then((response) => {
        let DecodeVal = Decrypt_Value(response.data, "vozo");
        setfutureId([DecodeVal]);
      })
      .catch(() => {
        setfutureId([]);
      });
  }, [patientId]);

  useEffect(() => {
    axiosInstance
      .get("/vozo/setting/facility")
      .then((response) => {
        const decoded = Decrypt_Value(response.data, "vozo");

        if (Array.isArray(decoded) && decoded.length > 0) {
          setFacilityInfo(decoded[0]);
        }
      })
      .catch((error) => {
        console.error("Facility fetch error:", error);
        setFacilityInfo(null);
      });
  }, []);

  useEffect(() => {
    fetchSingleScore();
  }, [patientId, screeningFormId]);

  const fetchSingleScore = async () => {
    if (!patientId || !screeningFormId) return;

    try {
      const params = new URLSearchParams(location.search);

      const currentStep = params.get("step");

      if (currentStep === "35.8" || currentStep === "35.9") {
        setRowData({
          screen_form_name: "PHQ - 9",
          scoring_guide: [
            { min: 0, max: 4, label: "Minimal" },
            { min: 5, max: 9, label: "Mild" },
            { min: 10, max: 14, label: "Moderate" },
            { min: 15, max: 21, label: "Severe" },
          ],
          Assessment_question: [
            {
              question_id: 1,
              question: "Little interest or pleasure in doing things",
            },
            {
              question_id: 2,
              question: "Feeling down, depressed, or hopeless",
            },
          ],
          Assessment_options: [
            { option_id: 1, question_id: 1, option: "Several days", score: 2 },
            {
              option_id: 2,
              question_id: 2,
              option: "More than half the days",
              score: 3,
            },
          ],
          Assessment_values: [
            { question_id: 1, selected_option_id: 1, score: 5 },
            { question_id: 2, selected_option_id: 2, score: 6 },
          ],
        });

        return;
      }
      const payload = { screening_form_id: screeningFormId };
      const encrypted = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.post(
        `/vozo/scoremeasure?pid=${patientId}`,
        encrypted,
      );

      if (
        !response.data ||
        response.data === "" ||
        (Array.isArray(response.data) && response.data.length === 0)
      ) {
        console.log("No score data returned");
        setRowData(null);
        return;
      }

      const decrypted = Decrypt_Value(response.data, "vozo");

      //console.log("Scoreboard.js", decrypted);

      setRowData(decrypted || null);
    } catch (error) {
      console.error("Scoreboard API error:", error);
      setRowData(null);
    }
  };

  const handleDownloadPDF = () => {
    if (!rowData) return;
    downloadScoreboardPDF(
      scoreboardPdfRef,
      rowData,
      rows[0],
      facilityInfo,
      rowData?.Assessment_name,
    );
  };

  const goToTreatmentPlan = () => {
    history.push(`/patient/treatmentplan/${patientId}`);
  };

  const goToMedication = () => {
    history.push(`/patient/medication/${patientId}`);
  };

  const goToActivityLog = () => {
    history.push(`/activitylog/${patientId}/${screeningFormId}`);
  };

  /* ================= TOTAL SCORE ================= */
  const dispatch = useDispatch();
  const [navData1, setNavData1] = useState("iconclose");

  const NavData1 = useSelector((state) => state.Schedule?.NavData);

  useEffect(() => {
    dispatch(GetSideNav("demographics"));
  }, []);

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);

  const location = useLocation();

  const currentScore = useMemo(() => {
    return (
      rowData?.Assessment_values?.reduce(
        (sum, item) => sum + (item?.score || 0),
        0,
      ) || 0
    );
  }, [rowData]);

  //   const scoringData = rowData?.Assessment_question?.map((q, index) => {
  //   const selected = rowData?.Assessment_values?.find(
  //     v => v.question_id === q.question_id
  //   );

  //   const selectedOption = rowData?.Assessment_options?.find(
  //     o => o.option_id === selected?.selected_option_id
  //   );

  //   return {
  //     key: index,
  //     sno: index + 1,
  //     question: q.question,
  //     response: selectedOption?.option || "-",
  //     score: selected ? `${selected.score}/3` : "- / 3"
  //   };
  // }) || [];
  const scoringData = (
    rowData?.Assessment_question?.map((q, index) => {
      const selected = rowData?.Assessment_values?.find(
        (v) => v.question_id === q.question_id,
      );

      let optionsForQuestion = [];
      if (Array.isArray(rowData?.Assessment_options)) {
        optionsForQuestion = rowData.Assessment_options.filter(
          (o) => o.question_id === q.question_id,
        );
      } else if (
        rowData?.Assessment_options &&
        typeof rowData.Assessment_options === "object"
      ) {
        optionsForQuestion = rowData.Assessment_options[q.question_id] || [];
      }

      // Highest score for this question
      const maxScoreForQuestion = optionsForQuestion.length
        ? Math.max(...optionsForQuestion.map((o) => o.score || 0))
        : 0;

      let responseText = "";
      if (selected) {
        if (Array.isArray(selected.selected_option_id)) {
          const matchedOptions = optionsForQuestion.filter((o) =>
            selected.selected_option_id.includes(o.option_id),
          );
          if (matchedOptions.length > 0) {
            responseText = matchedOptions.map((o) => o.option).join(", ");
          } else {
            responseText = selected.selected_option_id.join(", ");
          }
        } else {
          const selectedOption = optionsForQuestion.find(
            (o) => o.option_id === selected.selected_option_id,
          );
          responseText =
            selectedOption?.option ||
            selected.value ||
            selected.selected_option ||
            selected.selected_option_id;
        }
      }

      let additionalAnswersUI = null;
      if (
        q.additional_questions &&
        typeof q.additional_questions === "object"
      ) {
        let addVals = null;
        try {
          if (typeof rowData.additional_values === "string")
            addVals = JSON.parse(rowData.additional_values);
          else addVals = rowData.additional_values;

          if (!addVals) {
            if (typeof rowData.Patient_additional_values === "string")
              addVals = JSON.parse(rowData.Patient_additional_values);
            else addVals = rowData.Patient_additional_values;
          }
        } catch (e) {}

        if (addVals && responseText && q.additional_questions[responseText]) {
          const addQs = q.additional_questions[responseText];
          if (Array.isArray(addQs)) {
            additionalAnswersUI = addQs.map((aq) => {
              let ansObj = null;
              if (Array.isArray(addVals)) {
                ansObj = addVals.find((a) => a.question_id === aq.question_id);
              } else {
                ansObj = addVals[aq.question_id];
              }

              if (ansObj && ansObj.value) {
                return (
                  <div
                    key={aq.question_id}
                    style={{
                      marginTop: "6px",
                      fontSize: "13px",
                      color: "#555",
                      borderTop: "1px dashed #e8e8e8",
                      paddingTop: "4px",
                    }}
                  >
                    <span style={{ fontWeight: 500, marginRight: "4px" }}>
                      {aq.question}
                    </span>{" "}
                    {ansObj.value}
                  </div>
                );
              }
              return null;
            });
          }
        }
      }

      const isText = q.type === "text";

      // Mark whether this question was actually attempted by the patient
      const isAttempted =
        !!selected ||
        (isText && responseText && responseText !== "-" && responseText !== "");

      const responseNode = (
        <div>
          <div style={{ fontWeight: additionalAnswersUI ? 500 : 400 }}>
            {responseText || "-"}
          </div>
          {additionalAnswersUI}
        </div>
      );

      const currentAssessment =
        rowData?.screen_form_name ||
        rowData?.form_name ||
        rowData?.assessment_name ||
        rowData?.assess_form ||
        rowData?.Assessment_name;

      const nonScoredQIds = [
        "QA2",
        "Q27",
        "Q28",
        "Q29",
        "Q30",
        "Q31",
        "Q32",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "QA27",
        "QA28",
        "QA29",
        "QA30",
        "QA31",
        "QA32",
      ];

      const hideScore =
        (currentAssessment === "EAT-26" ||
          currentAssessment?.trim() === "EAT-26") &&
        nonScoredQIds.includes(String(q.question_id));

      return {
        key: index,
        sno: q.question_no || index + 1,
        question: q.question,
        response: responseNode,
        score:
          isText || hideScore
            ? ""
            : selected
              ? `${selected.score || 0}/${maxScoreForQuestion}`
              : `- / ${maxScoreForQuestion}`,
        isAttempted, // internal flag — used for filtering below
        section: q.section || "",
      };
    }) || []
  )
    // Show only questions the patient has actually answered
    .filter((row) => row.isAttempted);

  // Group questions by section for rendering
  // Questions without an explicit section inherit the previous section
  const sectionGroups = [];
  let currentGroup = null;
  let lastKnownSection = "";
  scoringData.forEach((row) => {
    const sec = row.section || lastKnownSection;
    if (row.section) lastKnownSection = row.section;
    if (!currentGroup || (row.section && currentGroup.section !== sec)) {
      currentGroup = { section: sec, rows: [] };
      sectionGroups.push(currentGroup);
    }
    currentGroup.rows.push(row);
  });
  const hasAnySections =
    sectionGroups.length > 1 ||
    (sectionGroups.length === 1 && sectionGroups[0].section);

  const columns = [
    { title: "S.No", dataIndex: "sno", width: "8%" },
    {
      title: "Questions",
      dataIndex: "question",
      width:
        rowData?.type === "normal_without_score" ||
        rowData?.type === "skip_without_score"
          ? "57%"
          : "42%",
    },
    { title: "Response", dataIndex: "response", width: "35%" },
    rowData?.type !== "normal_without_score" &&
      rowData?.type !== "skip_without_score" && {
        title: "Score",
        dataIndex: "score",
        width: "15%",
      },
  ].filter(Boolean);
  // const dynamicGuide = useMemo(() => {
  //   const guide = rowData?.scoring_guide || [];
  //   const colors = getDefaultColors(guide.length);

  //   return guide.map((item, index) => ({
  //     min: item.min,
  //     max: item.max,
  //     severity: item.label,
  //     score: `${item.min}-${item.max}`,
  //     color: colors[index] || "#999",
  //   }));
  // }, [rowData]);
  // const maxScore = dynamicGuide.length
  //   ? Math.max(...dynamicGuide.map((g) => g.max))
  //   : 10;

  // // const severityLevel =
  // //   dynamicGuide.find(g => currentScore >= g.min && currentScore <= g.max) ||
  // //   dynamicGuide[0];
  // const severityLevel = useMemo(() => {
  //   if (!dynamicGuide.length) return null;

  //   // Try normal range match
  //   const matched = dynamicGuide.find(
  //     (g) => currentScore >= g.min && currentScore <= g.max,
  //   );

  //   if (matched) return matched;

  //   // If score is greater than last max → return last range
  //   const lastRange = dynamicGuide[dynamicGuide.length - 1];

  //   if (currentScore > lastRange.max) {
  //     return lastRange;
  //   }

  //   // If score is lower than first min → return first range
  //   if (currentScore < dynamicGuide[0].min) {
  //     return dynamicGuide[0];
  //   }

  //   return null;
  // }, [currentScore, dynamicGuide]);

  // // const activeIndex = dynamicGuide.findIndex(
  // //   g => currentScore >= g.min && currentScore <= g.max
  // // );
  // const activeIndex = useMemo(() => {
  //   if (!dynamicGuide.length) return -1;

  //   const index = dynamicGuide.findIndex(
  //     (g) => currentScore >= g.min && currentScore <= g.max,
  //   );

  //   if (index !== -1) return index;

  //   // If score exceeds → highlight last segment
  //   if (currentScore > dynamicGuide[dynamicGuide.length - 1].max) {
  //     return dynamicGuide.length - 1;
  //   }

  //   // If below first → highlight first
  //   if (currentScore < dynamicGuide[0].min) {
  //     return 0;
  //   }

  //   return -1;
  // }, [currentScore, dynamicGuide]);

  // const showAlert = severityLevel?.severity?.toLowerCase().includes("severe");
  // /* ================= GAUGE ================= */

  // const radius = 80;
  // const strokeWidth = 12;
  // const center = 100;

  // const polarToCartesian = (cx, cy, r, angle) => {
  //   const rad = (angle - 180) * (Math.PI / 180);
  //   return {
  //     x: cx + r * Math.cos(rad),
  //     y: cy + r * Math.sin(rad),
  //   };
  // };

  // const describeArc = (startAngle, endAngle, color) => {
  //   const start = polarToCartesian(center, center, radius, endAngle);
  //   const end = polarToCartesian(center, center, radius, startAngle);
  //   return (
  //     <path
  //       d={`M ${start.x} ${start.y} A ${radius} ${radius} 0 0 0 ${end.x} ${end.y}`}
  //       stroke={color}
  //       strokeWidth={strokeWidth}
  //       fill="none"
  //       strokeLinecap="round"
  //     />
  //   );
  // };

  // const TOTAL_ARC = 180;
  // const SEGMENT_COUNT = dynamicGuide.length;
  // const GAP = 14;

  // const segmentAngle = (TOTAL_ARC - GAP * (SEGMENT_COUNT - 1)) / SEGMENT_COUNT;

  // const segments = dynamicGuide.map((item, i) => {
  //   const start = i * (segmentAngle + GAP);
  //   const end = start + segmentAngle;

  //   return {
  //     start,
  //     end,
  //     color: item.color,
  //   };
  // });
  const handleBack = () => {
    if (location.state?.returnPath) {
      history.push(location.state.returnPath);
    } else {
      history.goBack();
    }
  };

  const handleShowAdd = (portalId) => {
    setid(portalId);

    setEditDocName("");
    setcontent("");

    setShowAddForms(true);
  };
  const closeAddForms = () => {
    setShowAddForms(false);
    setEditDocName("");
    setcontent("");
  };

  const handleShowEdit = (portalId, note_file_url, form_name) => {
    if (!note_file_url) return;

    setid(portalId);

    const article = { path: note_file_url };
    let encrypted = Encrypt_Value(article, "vozo");

    axiosInstance
      .put("/vozo/patient/get/Document/one", encrypted)
      .then((response) => {
        console.log("RAW RESPONSE", response.data);
        let data = Decrypt_Value(response.data, "vozo");

        console.log("DECRYPTED RESPONSE", data);

        if (data) {
          setcontent(data);
          setEditDocName(form_name);
          setShowAddForms(true);
        } else {
          console.log("No content returned");
        }
      })
      .catch((err) => {
        console.error("Edit fetch error:", err);
      });
  };

  const savedocument = (
    temp,
    name,
    category,
    speciality,
    fortype,
    isAutoSave,
    SupType,
    provid,
    isSupervisor,
  ) => {
    const selected = rowData;

    if (!selected?.file_url) {
      var article = {
        temp: temp,
        path: "",
        pid: patientId,
        editdocname: name,
        uid: provider,
        category: category,
        speciality: speciality,
        type: "Dashboard",
      };

      let encrypted = Encrypt_Value(article, "vozo");

      axiosInstance
        .post(`/vozo/score/insertdocumenttemplatescore?id=` + id, encrypted)
        .then(() => {
          if (!isAutoSave) {
            setAlertMsg("Notes Saved successfully");
            setAlertType("success");
            setModalAlerShow(true);

            fetchSingleScore();

            setTimeout(() => setModalAlerShow(false), 1500);
            setShowAddForms(false);
          }
        });
    } else {
      var article = {
        temp: temp,
        path: selected.file_url,
        editdocname: name,
        conformid: id,
        category: category,
        speciality: speciality,
        uid: provider,
        type: " ",
      };

      let encrypted = Encrypt_Value(article, "vozo");

      axiosInstance
        .post("/vozo/updatedocument_template/data", encrypted)
        .then(() => {
          if (!isAutoSave) {
            setAlertMsg("Notes Saved successfully");
            setAlertType("success");
            setModalAlerShow(true);

            fetchSingleScore();

            setTimeout(() => setModalAlerShow(false), 1500);
            setShowAddForms(false);
          }
        });
    }
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("step") === "35.8") {
      setShowStep8Popup(true);
      setShowStep9Popup(false);
    }

    if (params.get("step") === "35.9") {
      setShowStep8Popup(false);
      setShowStep9Popup(true);
    }
  }, [location.search]);
  /* ================= UI ================= */
  return (
    <>
      <SideNav />

      <div
        className={
          navData1 === "iconopen"
            ? "nav_right  tl-mt-4 w-100 neg-marg-btm  m-r-13 "
            : "nav_right1  tl-mt-4 w-100 neg-marg-btm  m-r-13 "
        }
      >
        <div className="d-flex">
          <DemographicsPatientDetail />

          <div className="imm-main-block m-t-0 m-b-15 w-82-5">
            <div className="scoreboard-container">
              <div className="scoreboard-header">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>
                    <Button
                      type="text"
                      icon={<ArrowLeftOutlined />}
                      onClick={handleBack}
                      className="sb-back-arrow"
                      style={{ marginRight: "8px", marginBottom: "8px" }} // Added small bottom margin to align nicely with the h2 margin if it has one
                    />
                  </div>
                  <h2
                    ref={scoreBoardTitleRef}
                    className="scoreboard-title"
                    style={{ margin: 0 }}
                  >
                    Scoreboard
                  </h2>
                </div>

                <div className="scoreboard-buttons">
                  <Button
                    type={!rowData?.file_url ? "primary" : "default"}
                    className={`sb-btn ${
                      !rowData?.file_url ? "sb-btn-primary" : "sb-btn-edit"
                    }`}
                    onClick={() =>
                      !rowData?.file_url
                        ? handleShowAdd(rowData.portalid)
                        : handleShowEdit(
                            rowData.portalid,
                            rowData.file_url,
                            rowData.form_name,
                          )
                    }
                  >
                    {!rowData?.file_url ? "+ Add Notes" : "Edit Notes"}
                  </Button>
                  <Button
                    className="sb-btn sb-btn-secondary"
                    onClick={goToTreatmentPlan}
                  >
                    Treatment Plan
                  </Button>

                  <Button
                    className="sb-btn sb-btn-secondary"
                    onClick={goToMedication}
                  >
                    Medication
                  </Button>

                  <Button
                    className="sb-btn sb-btn-secondary"
                    onClick={goToActivityLog}
                  >
                    Activity Log
                  </Button>
                  <div ref={downloadBtnRef}>
                    <Button
                      // ref={downloadBtnRef}
                      icon={<DownloadOutlined />}
                      className="sb-btn sb-btn-icon"
                      onClick={handleDownloadPDF}
                    />
                  </div>
                </div>
              </div>

              <div className="scoreboard-content-box">
                {rowData && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-9999px",
                      left: "-9999px",
                      width: "1200px",
                    }}
                  >
                    <ScoreboardReportComponent
                      ref={scoreboardPdfRef}
                      rowData={rowData}
                      patientInfo={rows[0]}
                      facilityInfo={facilityInfo}
                    />
                  </div>
                )}

                {/* Gauge scorecard — render if display:"gauge" is set in calculations, OR legacy fallback */}
                {rowData?.type !== "normal_without_score" &&
                  rowData?.type !== "skip_without_score" &&
                  (() => {
                    let gaugesToRender = [];
                    let hasExplicitGauge = false;

                    // 1. Check if any calculation explicitly asks to be a "gauge"
                    if (
                      rowData?.calculations &&
                      Array.isArray(rowData.calculations)
                    ) {
                      const gaugeCalcIds = rowData.calculations
                        .filter((c) => c.display === "gauge")
                        .map((c) => c.id);
                      if (gaugeCalcIds.length > 0) {
                        hasExplicitGauge = true;
                        gaugesToRender = (rowData?.scores || []).filter((s) =>
                          gaugeCalcIds.includes(s.id),
                        );
                      }
                    }

                    // 2. Fallback: If NO explicit gauge config AND NO backend scoreboard, render all scores as gauges (legacy behavior)
                    if (!hasExplicitGauge && !rowData?.scoreboard) {
                      if (
                        rowData?.scores &&
                        Array.isArray(rowData.scores) &&
                        rowData.scores.length > 0
                      ) {
                        gaugesToRender = rowData.scores;
                      } else {
                        // Single score fallback
                        return (
                          <SingleGaugeDisplay
                            title={rowData?.screen_form_name || "Score"}
                            score={currentScore}
                            guideArray={rowData?.scoring_guide || []}
                          />
                        );
                      }
                    }

                    if (gaugesToRender.length === 0) return null;

                    return gaugesToRender.map((s, idx) => {
                      let guide = [];
                      if (
                        rowData.scoring_guide &&
                        !Array.isArray(rowData.scoring_guide)
                      ) {
                        guide =
                          rowData.scoring_guide[s.id] ||
                          rowData.scoring_guide[s.id.toLowerCase()] ||
                          [];
                      } else if (Array.isArray(rowData.scoring_guide)) {
                        guide = rowData.scoring_guide;
                      }
                      const displayTitle = s.id
                        ? s.id
                            .split("_")
                            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                            .join(" ")
                        : rowData.screen_form_name;
                      return (
                        <SingleGaugeDisplay
                          key={idx}
                          title={displayTitle}
                          score={s.score}
                          guideArray={guide}
                        />
                      );
                    });
                  })()}

                {/* Rule-based scoreboard (e.g., PHQ, VADRS, WHODAS) — rendered HTML from backend */}
                {rowData?.scoreboard && (
                  <div
                    className="scoreboard-html-table"
                    dangerouslySetInnerHTML={{ __html: rowData.scoreboard }}
                  />
                )}

                {/* Legacy subscale_scoring_guide table (for older forms that still use it) */}
                {rowData?.subscale_scoring_guide && (
                  <div
                    className="subscale-section"
                    style={{ marginTop: "30px", marginBottom: "30px" }}
                  >
                    <table
                      className="subscale-table-custom"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        backgroundColor: "#fff",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f9f9f9" }}>
                          <th
                            className="subscale-header-title"
                            style={{
                              padding: "12px 15px",
                              textAlign: "left",
                              color: "#333",
                              borderBottom: "2px solid #e0e0e0",
                            }}
                          >
                            Subscale
                          </th>
                          <th
                            className="subscale-header-score"
                            style={{
                              padding: "12px 15px",
                              textAlign: "center",
                              color: "#333",
                              borderBottom: "2px solid #e0e0e0",
                            }}
                          >
                            Score
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(rowData?.subscale_scoring_guide).map((sub, idx) => (
                          <tr
                            key={idx}
                            className="subscale-custom-row"
                            style={{ borderBottom: "1px solid #f0f0f0" }}
                          >
                            <td
                              className="subscale-title-desc"
                              style={{ padding: "12px 15px" }}
                            >
                              <div
                                className="subscale-title-text"
                                style={{ fontWeight: "600", color: "#444" }}
                              >
                                {sub.subscale ||
                                  sub.title ||
                                  sub.name ||
                                  sub.subscale_name}
                              </div>
                              {(sub.description || sub.desc) && (
                                <div
                                  className="subscale-desc-text"
                                  style={{
                                    fontSize: "13px",
                                    color: "#777",
                                    marginTop: "4px",
                                  }}
                                >
                                  {sub.description || sub.desc}
                                </div>
                              )}
                            </td>
                            <td
                              className="subscale-score-value"
                              style={{
                                padding: "12px 15px",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              {sub.score}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {rowData?.headers && (
                  <div
                    className="scoreboard-header-content"
                    dangerouslySetInnerHTML={{ __html: rowData.headers }}
                  />
                )}

                <div className="questions-table">
                  {hasAnySections ? (
                    <>
                      <Table
                        columns={columns}
                        dataSource={[]}
                        pagination={false}
                        bordered={false}
                        showHeader={true}
                        locale={{ emptyText: <></> }}
                        className="section-header-only-table"
                      />
                      {sectionGroups.map((group, gIdx) => (
                        <div key={gIdx}>
                          {group.section && (
                            <div
                              className="scoreboard-section-header"
                              style={{
                                background: "#f0f4f8",
                                padding: "10px 16px",
                                fontWeight: 600,
                                fontSize: "15px",
                                color: "#1e293b",
                                borderTop:
                                  gIdx !== 0 ? "1px solid #e2e8f0" : "none",
                                borderBottom: "1px solid #e2e8f0",
                                textAlign: "left",
                              }}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: group.section,
                                }}
                              />
                            </div>
                          )}
                          <Table
                            columns={columns}
                            dataSource={group.rows}
                            pagination={false}
                            bordered={false}
                            showHeader={false}
                          />
                        </div>
                      ))}
                    </>
                  ) : (
                    <Table
                      columns={columns}
                      dataSource={scoringData}
                      pagination={false}
                      bordered={false}
                    />
                  )}
                </div>

                {rowData?.footers && (
                  <div
                    className="scoreboard-footer-content"
                    dangerouslySetInnerHTML={{ __html: rowData.footers }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="client-popup-for-billing-profiles popup_centre"
        centered
        show={ShowAddForms}
        onHide={() => {
          setShowAddForms(false);
          setEditDocName("");
          setcontent("");
        }}
      >
        <Modal.Body
          className="ed-doc-mod-body"
          id="cnst_frm-mod_bdy"
          style={{ padding: 0 }}
        >
          {rows.length > 0 && (
            <TemplateWorkAreas
              closeTemplate={() => {
                setShowAddForms(false);
                setEditDocName("");
                setcontent("");
              }}
              savetemplate={savedocument}
              EditDocName={EditDocName}
              content={content}
              patientdetails={rows[0]}
              fromTemplate="Dashboard"
              eid=""
              portalid={id}
              onHide={closeAddForms}
            />
          )}
        </Modal.Body>
      </Modal>

      <Modal className="alert-popup-message" show={ModalAlerShow}>
        <div className={`alert msg alert-${alertType}`} role="alert">
          {alertType === "success" ? (
            <BsCheckCircle className="icons-bs" />
          ) : (
            <BsXCircle className="icons-bs" />
          )}{" "}
          {AlertsMsg}
        </div>
      </Modal>
      <Popup
        open={showStep8Popup}
        position="left center"
        context={downloadBtnRef.current}
        offset={[70, 10]}
        style={{ zIndex: 400 }}
        content={
          <GetStartedPopup
            title="View Outcome Measures"
            // description="View assessment score and download the report."
            bullets={[
              "View the assessment score for the questions.",
              "Take immediate actions based on the Critical alerts using the available options.",
              "You can also download the full report by clicking the download icon.",
            ]}
            width={300}
            currentStep={8}
            totalSteps={10}
            onBack={() => {
              setShowStep8Popup(false);

              history.push(`/patient/measures/${patientId}?tab=3&step=35.7`);
            }}
            onNext={() => {
              setShowStep8Popup(false);

              history.push(
                `/scoreboard/${patientId}/${screeningFormId}?step=35.9&source=measures`,
              );
            }}
            onClose={() => {
              setShowStep8Popup(false);
            }}
          />
        }
        trigger={<div />}
      />
      <Popup
        open={showStep9Popup}
        position="right center"
        offset={[50, 10]}
        style={{ zIndex: 400 }}
        context={scoreBoardTitleRef.current}
        content={
          <GetStartedPopup
            title="View Outcome Measures"
            description="Navigate back to view the Outcome Measure section to view the graphical view of the scores based on various dates."
            currentStep={9}
            totalSteps={10}
            width={300}
            onBack={() => {
              setShowStep9Popup(false);

              history.push(
                `/scoreboard/${patientId}/${screeningFormId}?step=35.8&source=measures`,
              );
            }}
            onNext={() => {
              setShowStep9Popup(false);

              history.push(`/patient/measures/${patientId}?tab=3&step=35.10`);
            }}
            onClose={() => {
              setShowStep9Popup(false);
            }}
          />
        }
        trigger={<div />}
      />
    </>
  );
};
export default Scoreboard;
